import { render, staticRenderFns } from "./ConsistencyAnalysisLegend.vue?vue&type=template&id=01601c34&scoped=true"
import script from "./ConsistencyAnalysisLegend.vue?vue&type=script&lang=ts"
export * from "./ConsistencyAnalysisLegend.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01601c34",
  null
  
)

export default component.exports